import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "/" },
  { label: "游戏资源", href: "/#library" },
  { label: "下载指南", href: "/#guide" },
  { label: "常见问题", href: "/#faq" },
  { label: "关于我们", href: "/#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleAnchor = (href: string) => {
    setOpen(false);
    if (href.includes("#")) {
      const id = href.split("#")[1];
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3.5">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-white"
            }`}
          >
            火影同人游戏库
          </span>
        </Link>

        <ul className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                onClick={() => handleAnchor(link.href)}
                className={`whitespace-nowrap text-sm font-medium transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-white/90 hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="hidden md:block">
          <a
            href="#library"
            onClick={(e) => {
              e.preventDefault();
              handleAnchor("/#library");
            }}
            className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-accent-600"
          >
            立即下载
          </a>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            scrolled ? "text-foreground-900" : "text-white"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <ul className="flex flex-col px-4 py-3">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  onClick={() => handleAnchor(link.href)}
                  className="block rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="#library"
                onClick={(e) => {
                  e.preventDefault();
                  handleAnchor("/#library");
                }}
                className="mt-2 block rounded-md bg-accent-500 px-3 py-3 text-center text-sm font-semibold text-white"
              >
                立即下载
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}